import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkerAlt,
  faPhone,
  faMobileAlt,
  faEnvelope,
  faExternalLinkAlt,
  faClock,
} from '@fortawesome/free-solid-svg-icons';

export default function Contacto() {
  return (
    <section id="contacto" className="bg-[#f28c281a] py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-semibold mb-8 text-[#0033A0] text-center">Contacto</h2>

        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6">
          <div className="flex items-center space-x-4 text-gray-700 text-lg">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-[#F28C28] text-2xl" />
            <span>López Rayón #18, El Grullo, Jalisco</span>
          </div>

          <div className="flex items-center space-x-4 text-gray-700 text-lg">
            <FontAwesomeIcon icon={faPhone} className="text-[#F28C28] text-2xl" />
            <span>321 387 2406</span>
          </div>

          <div className="flex items-center space-x-4 text-gray-700 text-lg">
            <FontAwesomeIcon icon={faMobileAlt} className="text-[#F28C28] text-2xl" />
            <span>321 100 9701 (WhatsApp)</span>
          </div>

          <div className="flex items-center space-x-4 text-gray-700 text-lg">
            <FontAwesomeIcon icon={faEnvelope} className="text-[#F28C28] text-2xl" />
            <a
              href="mailto:pblatatia@hotmail.com"
              className="text-blue-700 underline hover:text-blue-900 transition"
            >
              pblatatia@hotmail.com
            </a>
          </div>

          {/* Mapa incrustado */}
          <div className="mt-8 rounded-xl overflow-hidden shadow-md">
            <iframe
              title="Ubicación La Tapatía"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.052789843917!2d-104.2222553!3d19.8053099!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842f7a5bd1ba8e2b%3A0xd274216d47c6a3d4!2sL%C3%B3pez%20Ray%C3%B3n%2018%2C%20El%20Grullo%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1721155050000!5m2!1ses-419!2smx"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Botón para abrir Google Maps */}
          <div className="text-center mt-6">
            <a
              href="https://www.google.com/maps/place/L%C3%B3pez+Ray%C3%B3n+18,+El+Grullo,+Jalisco"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-[#F28C28] hover:bg-[#cc751f] text-white font-semibold rounded-full px-6 py-3 shadow-lg transition"
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} />
              Ver en Google Maps
            </a>
          </div>

          {/* Horario de atención */}
          <div className="flex items-start space-x-4 text-gray-700 text-lg">
            <FontAwesomeIcon icon={faClock} className="text-[#F28C28] text-2xl mt-1" />
            <div>
              <p className="font-semibold">Horario de atención:</p>
              <p>Lunes a Sábado: 7:30 am - 7:30 pm</p>
              <p>Domingo: 8:00 am - 3:00 pm</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
